const widgets = document.querySelectorAll('[data-elfsight-app-lazy]');

if (widgets.length) {
    const loadPlatform = () => {
        if (document.querySelector('script[data-elfsight-platform]')) return;

        const script = document.createElement('script');
        script.src = 'https://elfsightcdn.com/platform.js';
        script.async = true;
        script.dataset.elfsightPlatform = '';
        document.head.appendChild(script);
    };

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;

            observer.disconnect();
            loadPlatform();
        }, { rootMargin: '600px 0px' });

        widgets.forEach((widget) => observer.observe(widget));
    } else {
        loadPlatform();
    }
}
